import { daysInMonth } from './gregorianmath';
import { TIME_PERIOD_FIELDS } from './interval';
import { substituteZoneAlias, zoneInfoFromUTC } from './timezone';
var floor = Math.floor;
/**
 * Extract year, month, and day fields.
 */
export var toYMD = function (d) { return ({
    year: d.extendedYear(),
    month: d.month(),
    day: d.dayOfMonth(),
}); };
/**
 * Given a Julian day and local milliseconds (in UTC), return the Unix
 * epoch milliseconds UTC.
 */
export var unixEpochFromJD = function (jd, msDay) {
    var days = jd - 2440588 /* CalendarConstants.JD_UNIX_EPOCH */;
    return days * 86400000 /* CalendarConstants.ONE_DAY_MS */ + Math.round(msDay);
};
// TODO: reorganize calendar math
// export const jdToYMD = (jd: number, millis: number, zoneId: string): YearMonthDay => {
//   const f = dateFields();
//   const epoch = unixEpochFromJD(jd, millis);
//   initBaseFromUnixEpoch(f, epoch, zoneId);
//   initGregorianFields(f);
//   return {
//     year: f[DateField.EXTENDED_YEAR],
//     month: f[DateField.MONTH],
//     day: f[DateField.DAY_OF_MONTH],
//   };
// };
/**
 * Ensure n falls between min and max.
 */
export var clamp = function (n, min, max) { return Math.min(max, Math.max(min, n)); };
/**
 * Ensure that the year, month, and day represent a valid date, clamping the
 * month and day fields to a valid range.
 */
export var clampYMD = function (year, monthArg, d) {
    var month = clamp(monthArg, 1, 12);
    var day = clamp(d, 1, daysInMonth(year, month - 1));
    return { year: year, month: month, day: day };
};
/**
 * Adjust the year and month to ensure they represent part of a valid date.
 */
export var adjustYM = function (yearp, monthp) {
    var year = yearp;
    var month = monthp;
    month -= 1;
    year += Math.floor(month / 12);
    month %= 12;
    if (month < 0) {
        month += 12;
    }
    month += 1;
    return { year: year, month: month };
};
/**
 * Add time fields in milliseconds.
 */
export var adjustTime = function (millis, added) {
    var ms = millis + timeToMillis(added);
    // Extract days from the time fields and add them.
    var days = (ms / 86400000 /* CalendarConstants.ONE_DAY_MS */) | 0;
    ms -= days * 86400000 /* CalendarConstants.ONE_DAY_MS */;
    return [days, ms];
};
export var timeToMillis = function (period) {
    return ((period.hour || 0) * 3600000 /* CalendarConstants.ONE_HOUR_MS */ +
        (period.minute || 0) * 60000 /* CalendarConstants.ONE_MINUTE_MS */ +
        (period.second || 0) * 1000 /* CalendarConstants.ONE_SECOND_MS */ +
        (period.millis || 0));
};
/**
 * Keep the integral part of each field and replace undefined with zero.
 */
export var truncateFields = function (fields) {
    var result = {};
    for (var _i = 0, TIME_PERIOD_FIELDS_1 = TIME_PERIOD_FIELDS; _i < TIME_PERIOD_FIELDS_1.length; _i++) {
        var key = TIME_PERIOD_FIELDS_1[_i];
        result[key] = Math.trunc(fields[key] || 0);
    }
    return result;
};
/**
 * Compute Julian day from timezone-adjusted Unix epoch milliseconds.
 */
export var fieldsFromUnixEpoch = function (ms, f) {
    var _a = jdFromUnixEpoch(ms), jd = _a[0], msDay = _a[1];
    f[1 /* DateField.JULIAN_DAY */] = jd;
    f[13 /* DateField.MILLIS_IN_DAY */] = msDay;
};
/**
 * Compute the Julian day and the milliseconds remainder from a Unix epoch timestamp.
 */
export var jdFromUnixEpoch = function (ms) {
    var days = floor(ms / 86400000 /* CalendarConstants.ONE_DAY_MS */);
    var jd = days + 2440588 /* CalendarConstants.JD_UNIX_EPOCH */;
    var msDay = floor(ms - days * 86400000 /* CalendarConstants.ONE_DAY_MS */);
    return [jd, msDay];
};
/**
 * Initialize base calendar fields.
 */
export var initBaseFromUnixEpoch = function (f, ms, zoneId) {
    zoneId = substituteZoneAlias(zoneId);
    var zoneInfo = zoneInfoFromUTC(zoneId, ms);
    fieldsFromUnixEpoch(ms + zoneInfo.offset, f);
    computeBaseFields(f);
    return zoneInfo;
};
/**
 * Compute fields common to all calendars. Before calling this, we must
 * have the JULIAN_DAY and MILLIS_IN_DAY fields set. Every calculation
 * is relative to these.
 */
export var computeBaseFields = function (f) {
    var jd = clamp(f[1 /* DateField.JULIAN_DAY */], 0 /* CalendarConstants.JD_MIN */, 4881503 /* CalendarConstants.JD_MAX */);
    // checkJDRange(jd);
    var msDay = f[13 /* DateField.MILLIS_IN_DAY */];
    var ms = msDay + (jd - 2440588 /* CalendarConstants.JD_UNIX_EPOCH */) * 86400000 /* CalendarConstants.ONE_DAY_MS */;
    f[0 /* DateField.LOCAL_MILLIS */] = ms;
    f[1 /* DateField.JULIAN_DAY */] = jd;
    f[13 /* DateField.MILLIS_IN_DAY */] = msDay;
    f[19 /* DateField.MILLIS */] = msDay % 1000;
    msDay = (msDay / 1000) | 0;
    f[18 /* DateField.SECOND */] = msDay % 60;
    msDay = (msDay / 60) | 0;
    f[17 /* DateField.MINUTE */] = msDay % 60;
    msDay = (msDay / 60) | 0;
    f[15 /* DateField.HOUR_OF_DAY */] = msDay;
    f[14 /* DateField.AM_PM */] = (msDay / 12) | 0;
    f[16 /* DateField.HOUR */] = msDay % 12;
    var dow = (jd + 2 /* DayOfWeek.MONDAY */) % 7;
    if (dow < 1 /* DayOfWeek.SUNDAY */) {
        dow += 7;
    }
    f[11 /* DateField.DAY_OF_WEEK */] = dow;
};
//# sourceMappingURL=math.js.map